import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import { useGameStore } from '../store/gameStore';

export const TeamScores: React.FC = () => {
  const currentTeam = useGameStore((state) => state.currentTeam);
  const redCards = useGameStore((state) => state.redCards);
  const blueCards = useGameStore((state) => state.blueCards);
  const { t } = useTranslation();

  return (
    <div className="team-scores">
      <div className={`team-score red ${currentTeam === 'red' ? 'active' : ''}`}>
        {t.redTeam}: {redCards}
      </div>
      <div className={`team-score blue ${currentTeam === 'blue' ? 'active' : ''}`}>
        {t.blueTeam}: {blueCards}
      </div>
    </div>
  );
};
